import { Injectable } from '@angular/core';
import { CreatorStateService } from '../services/app-services';
import { IPriorityShape } from '../interfaces';
import { DEFAULT_PRIORITY_SHAPE_DATA } from '../constants';
import { PriorityShapesFactory } from '../factories/priority-shapes.factory';

@Injectable()
export class PriorityShapeManager {

  private static readonly _priorityShapesFactory = new PriorityShapesFactory();

  public static getHTMLElement(): HTMLElement {
    return CreatorStateService.roomRef.nativeElement.querySelector<HTMLElement>(
      `[data-priority-shape]`
    ) || null;
  }

  public static transformHTMLElementToObject(el: HTMLElement): IPriorityShape {
    const baseData = {
      x: parseInt(el.style.left),
      y: parseInt(el.style.top),
      w: el.style.width ? parseInt(el.style.width) : DEFAULT_PRIORITY_SHAPE_DATA.w,
      h: el.style.height ? parseInt(el.style.height) : DEFAULT_PRIORITY_SHAPE_DATA.h,
    } as Partial<IPriorityShape>;

    return PriorityShapeManager.formatObject(baseData);
  }

  public static formatObject(shape?: Partial<IPriorityShape>): IPriorityShape {
    const priorityShape = CreatorStateService.priorityShape;
    const shapeType = shape?.shapeType ?? priorityShape?.shapeType ?? DEFAULT_PRIORITY_SHAPE_DATA.shapeType;

    return {
      x: shape?.x ?? priorityShape?.x ?? DEFAULT_PRIORITY_SHAPE_DATA.x,
      y: shape?.y ?? priorityShape?.y ?? DEFAULT_PRIORITY_SHAPE_DATA.y,
      w: shape?.w ?? priorityShape?.w ?? DEFAULT_PRIORITY_SHAPE_DATA.w,
      h: shape?.h ?? priorityShape?.h ?? DEFAULT_PRIORITY_SHAPE_DATA.h,
      shapeType,
      rotate: shape?.rotate ?? priorityShape?.rotate ?? DEFAULT_PRIORITY_SHAPE_DATA.rotate,
      shape: shape?.shape ?? priorityShape?.shape ?? this._priorityShapesFactory.getPriorityShapePolygon(shapeType)
    };
  }
}
